import { Participant } from "@local-types/participant/tableRow";

export const sortParticipantsByName = (
  participants: Participant[],
): Participant[] => {
  return [...participants].sort((a, b) =>
    a.name.localeCompare(b.name, "ru", { sensitivity: "base" }),
  );
};
